/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Subtract from '../../images/subtract.png';

const AnonDashboardHeader = ({ tenant }) => (
  <div
    id='dashboard-header-cta'
    style={{ backgroundImage: `url(${Subtract})` }}
  >
    <div className='wrapper'>
      <h1 style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)', lineHeight: 1.15 }}>
        {tenant.anonymousHeaderText ||
          'Fresh opportunities for smart investors.'}
      </h1>
      <Link className='small button' to='/register'>
        Join for Free
      </Link>
    </div>
  </div>
);

const mapStateToProps = ({ tenant }) => ({
  tenant,
});

AnonDashboardHeader.propTypes = {
  tenant: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(AnonDashboardHeader);



// WEBPACK FOOTER //
// ./src/components/Dashboard/AnonDashboardHeader.js